const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const HoverRegion = require("./HoverRegion");

// Container for dropdown menu that handles animating its children up and down
// when isActive changes. Animation done via css transitions attached to the
// dropdown container.

module.exports = createReactClass({
	displayName: "DropdownContainer",

	propTypes: {
		isActive: PT.bool.isRequired,
		children: PT.node.isRequired,
		activeClassName: PT.string,
		inactiveClassName: PT.string,
		style: PT.object,
		onEnter: PT.func,
		onLeave: PT.func,
	},

	render: function() {
		const {children, style, onEnter, onLeave} = this.props;
		const {isActive, activeClassName, inactiveClassName} = this.props;
		const className = isActive ? activeClassName : inactiveClassName;
		return (
			<div className={className} style={style}>
				<HoverRegion onEnter={onEnter} onLeave={onLeave} noSpecialTouch={true}>
					{children}
				</HoverRegion>
			</div>
		);
	},
});
